<div class="reverse-mortgage-container">

  <div class="pageHeader" id="reverseMortgageHeader">
    <span>Reverse Mortgage</span>
  </div>

  <div class="message" *ngIf="servicingBannerMsg != null && servicingBannerMsg.length >0">
    <span>{{servicingBannerMsg}}</span>
  </div>
  <div class="message" *ngIf="deliveryBannerMsg != null && deliveryBannerMsg.length >0">
    <span>{{deliveryBannerMsg}}</span>
  </div>

  <div *ngIf="deliveryIndicator === 'true' && rmIndicator ==='true'">
  <div class="delivery" *ngIf="rmIntView || rmIntUpdate || isAdmin || isDeveloper || rmExtDelView || rmExtDelUpdate">
    <div class="delivery-header">
      <span> Delivery </span>
    </div>

    <div class="delivery-container">

      <div *ngIf="rmIntView || rmIntUpdate || isAdmin || isDeveloper || rmExtDelView || rmExtDelUpdate">
        <a routerLink="/searchupdateloan">
          <span> Search &amp; Update Loans </span>
        </a>
        <span> - Search and Update a Loan </span>
      </div>

      <div *ngIf="rmIntView || rmIntUpdate || isAdmin || isDeveloper || rmExtDelView || rmExtDelUpdate">
        <a routerLink="/deliveryViewPurchaseAdvice">
          <span> View Purchase Advice </span>
        </a>
        <span> - View Purchase Advice Report </span>
      </div>

      <div *ngIf="rmExtDelUpdate">
        <a href="" routerLink="/contactInfo">
          <span>Contact Info</span>
        </a>
        <span>&nbsp;- Contact Info </span>
      </div>

    </div>
  </div>

  </div>
  <div *ngIf="servicingIndicator === 'true' && rmIndicator ==='true'">
  <div class="account-reporting" *ngIf="rmIntView || rmIntUpdate || isAdmin || isDeveloper || rmExtSerView || rmExtSerpdate">

    <div class="accounting-reporting-header">
      <span> Accounting / Reporting </span>
    </div>

    <div class="accounting-reporting-header-container">

      <div *ngIf="rmIntView || rmIntUpdate || isAdmin || isDeveloper || rmExtSerView || rmExtSerpdate">
        <a href="" routerLink="/queryLoans">
          <span> Query Loans </span>
        </a>
        <span> - Query Loans </span>
      </div>

      <div *ngIf="rmIntView || rmIntUpdate || isAdmin || isDeveloper || rmExtSerView || rmExtSerpdate">
        <a href="" routerLink="/queryTransactions">
          <span> Query Transactions </span>
        </a>
        <span> - Query Transactions </span>
      </div>


      <div *ngIf="rmIntView || rmIntUpdate || isAdmin || isDeveloper || rmExtSerView || rmExtSerpdate">
        <a href="" routerLink="/queryServicerTransfers">
          <span> Query Servicer Transfers </span>
        </a>
        <span>&nbsp;-&nbsp;Query Servicer Transfers </span>
      </div>

      <div *ngIf="rmIntUpdate || isAdmin || isDeveloper || rmExtSerpdate">
        <a href="" routerLink="/transactions">
          <span> Perform Transactions </span>
        </a>
        <span> - Perform Transactions </span>
      </div>

      <div *ngIf="rmIntView || rmIntUpdate || isAdmin || isDeveloper || rmExtSerView || rmExtSerpdate">
        <a  routerLink="/accountingReports">
          <span> Reports </span>
        </a>
        <span> - View Reports Available </span>
      </div>

      <div *ngIf="rmIntView || rmIntUpdate || isAdmin || isDeveloper || rmExtSerView || rmExtSerpdate">
        <a routerLink="/accountingViewPurchaseAdvice">
          <span> View Purchase Advice  </span>
        </a>
        <span> - View Purchase Advice Report </span>
      </div>

      <div *ngIf="rmIntUpdate || isAdmin || isDeveloper || rmExtSerpdate">
        <a href="" routerLink="/submitTrialBalance">
          <span>  Submit Trial Balance </span>
        </a>
        <span> -  Submit Trial Balance </span>
      </div>

      <div *ngIf="rmIntView || rmIntUpdate || isAdmin || isDeveloper || rmExtSerView || rmExtSerpdate">
        <a routerLink="/viewtransmission">
          <span>  View Transmission </span>
        </a>
        <span> -  View Transmission</span>
      </div>

      <div *ngIf="rmIntUpdate || isAdmin || isDeveloper || rmExtSerpdate">
        <a routerLink="/uploadFile">
          <span>  Upload File </span>
        </a>
        <span> - Upload a File </span>
      </div>

    </div>


  </div>
  </div>
</div>
